/*
 * @FilePath: index.js
 * @Author: 孙新宇
 * @Date: 2022-12-27 09:15:51
 * @LastEditTime: 2023-01-04 08:48:04
 * @Descripttion: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ArticleList from '../views/ArticleList.vue'
import ArticleDetail from '../views/ArticleDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/article/:category',
    name: 'article',
    component: ArticleList,
    props: true,
    // meta: {
    //   keepAlive: true,
    // },
    // props: route => ({ query: route.query.q })
  },
  {
    path: '/article/:category/detail/:id',
    name: 'detail',
    component: ArticleDetail,
    props: true,
    // meta: {
    //   keepAlive: false,
    // },
    // props: route => ({ query: route.query.q })
  },
]

const router = new VueRouter({
  routes
})

export default router
